import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Toast from '../../components/forms/Toast';
import Icon from '../../components/common/Icon';
import AuthShell from './AuthShell';
import { apiRequest, handleSessionRedirect, handleBranding } from '../../utils';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // Follow the brand the visitor arrived under (BU colours/photo), same as
    // Login/ClaimTicket — otherwise the reset page stays the bare default.
    handleBranding();
    const checkAuth = async () => {
      try {
        const data = await apiRequest('GET', '/check-auth');
        if (data.message === 'Authenticated') {
          handleSessionRedirect(navigate, true);
        }
      } catch (e) {
        console.error('Error checking authentication:', e.message);
      }
    };
    checkAuth();
  }, [navigate]);

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const formData = new FormData(event.target);
    const values = Object.fromEntries(formData.entries());
    // The brand the visitor arrived under, so the reset MAIL wears it too —
    // the page already does (handleBranding above), but the server has no
    // event to resolve a sender/template from without this.
    const brandSlug = localStorage.getItem('brandSlug');
    if (brandSlug) values.brand_slug = brandSlug;

    try {
      const data = await apiRequest('POST', '/forgot-password', values);
      setError(null);
      setSuccess(data.message);
      setShowToast(true);
    } catch (e) {
      setError(t('somethingWentWrong'));
      setSuccess(null);
      setShowToast(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title={t('forgotPassword')}
      subtitle={t('forgotPasswordSubtitle', { defaultValue: "We'll email you a link to reset it." })}
      footer={
        <Link to="/login" className="auth__back-link">
          <Icon name="angle-left" /> {t('backToLogin')}
        </Link>
      }
    >
      <form className="auth__card" onSubmit={onSubmit}>
        <p className="auth__hint">{t('forgotPasswordInstructions')}</p>

        <div className="auth__field">
          <label className="auth__label">{t('email')}</label>
          <div className="auth__input-wrap">
            <input
              className="auth__input"
              type="email"
              name="email"
              placeholder={t('enterEmail')}
              required
              autoComplete="email"
            />
          </div>
        </div>

        <button type="submit" className="auth__primary" disabled={submitting}>
          {submitting ? <span className="auth__spinner" /> : <Icon name="paper-plane" />}
          {t('sendEmail')}
        </button>

        <Toast
          showToast={showToast}
          setShowToast={setShowToast}
          message={success ? t(success) : t(error)}
          icon={success ? 'check-circle' : 'exclamation'}
        />
      </form>
    </AuthShell>
  );
};

export default ForgotPassword;
